import React from 'react';
import PropTypes from 'prop-types';
import {FormGroup, FormControl, FormHelperText, FormLabel} from '@material-ui/core';
import {isEmpty} from 'lodash/lang';
import {formShape} from 'rc-form';

export default class WrapperField extends React.Component {
  static propTypes = {
    form: formShape.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    rules: PropTypes.array.isRequired,
    initialValue: PropTypes.any,
    helpText: PropTypes.string.isRequired,
    render: PropTypes.func.isRequired,
  };
  static defaultProps = {
    rules: [],
    helpText: '',
    options: [],
  };

  render() {
    const {
      name,
      label,
      rules,
      initialValue,
      helpText,
      render,
      form: {getFieldProps, getFieldError},
    } = this.props;
    let errors = getFieldError(name);
    let hasError = !isEmpty(errors);
    let error;
    if (hasError) {
      error = errors[0];
    }

    const fieldProps = getFieldProps(name, {
      validate: [{trigger: 'onChange', rules}],
      initialValue,
    });

    return (
      <FormGroup className="mui-form-group">
        <FormControl error={hasError}>
          <FormLabel component="legend">{label}</FormLabel>
          {render({fieldProps})}
          {helpText && <FormHelperText error={false}>{helpText}</FormHelperText>}
          <FormHelperText error={hasError}>{error}</FormHelperText>
        </FormControl>
      </FormGroup>
    );
  }
}
